module.exports = __webpack_public_path__ + "assets/ee533674ba1853eaba3c4f5a70ae88f4.png";